import { useMemo } from "react";
import { Client } from "types";

export const useFilteredClients = (search: string, clientList: Client[]) => {
  return useMemo(
    () =>
      clientList.filter(
        (item) =>
          item.secondname?.toLowerCase().includes(search.toLowerCase()) ||
          item.firstname?.toLowerCase().includes(search.toLowerCase()) ||
          item.phone?.toLowerCase().includes(search.toLowerCase()) ||
          item.percent?.toLowerCase().includes(search.toLowerCase()) ||
          item.otc?.toLowerCase().includes(search.toLowerCase())
      ),
    [clientList, search]
  );
};
